export const MOCK_UPCOMING_ASSIGNMENTS = [
  {
    slug: "assignment-mock-001",
    booking: {
      slug: "booking-2026-0142",
      location: { siteName: "Leicester Distribution Centre" },
      createdBy: { fullName: "Northbridge Logistics Ltd" },
    },
    role: { title: "Warehouse operative" },
    dates: ["2026-07-02", "2026-07-03", "2026-07-04"],
    shift: { startTime: "06:00", endTime: "14:00" },
    expiresAt: "2026-07-01T18:00:00.000Z",
    createdAt: "2026-06-20T09:15:00.000Z",
  },
  {
    slug: "assignment-mock-002",
    booking: {
      slug: "booking-2026-0198",
      location: { siteName: "City Retail – Highcross" },
      createdBy: { fullName: "City Retail Group" },
    },
    role: { title: "Retail assistant" },
    dates: ["2026-07-08", "2026-07-09"],
    shift: { startTime: "10:00", endTime: "18:00" },
    expiresAt: "2026-07-07T12:00:00.000Z",
    createdAt: "2026-06-22T14:30:00.000Z",
  },
  {
    slug: "assignment-mock-003",
    booking: {
      slug: "booking-2026-0211",
      location: { siteName: "Stadium Events – Gate A" },
      createdBy: { fullName: "EventStaff UK" },
    },
    role: { title: "Event steward" },
    dates: ["2026-07-12"],
    shift: { startTime: "16:00", endTime: "23:00" },
    expiresAt: "2026-07-11T20:00:00.000Z",
    createdAt: "2026-06-25T11:00:00.000Z",
  },
];
